import * as React from 'react';
import { Carousel } from 'react-responsive-carousel';
import '../../../../../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export interface IPersonImageProps {
  space: string,
  images: any[],
};

export interface IPersonImageState {
  photoIndex: number,
  isOpen: boolean,
};

export class PersonImage extends React.Component<IPersonImageProps, IPersonImageState> {
  constructor(props: IPersonImageProps) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  public render() {
    const { photoIndex, isOpen } = this.state;
    let images = ['https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg'];
    const filteredImages = this.props.images.filter(image => image !== "")
    images = filteredImages.length > 0 ? filteredImages : images;
    return (
      <div className={'person-image'} >
        <div className={"panel panel-info "}>
          {
            isOpen &&
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + images.length - 1) % images.length,
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % images.length,
                })
              }
            />
          }
          <div className="row panel-body">
            <div className="col-md-12 col-lg-12">
              <div className="imageContainer">
                <Carousel showArrows={true} showThumbs={false} >
                  {
                    images.map((image) => {
                      return (
                        <div key={image} onClick={() => this.setState({ isOpen: true })}>
                          <img src={image} />
                        </div>
                      );
                    })
                  }
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default PersonImage;



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/Poster/components/PersonImage.tsx